import { useEffect, useState } from 'react';
import type { CapiProductPage } from 'types/capi/pdp';

import usePageData from '~/hooks/usePageData';
import useUser from '~/hooks/useUser';
import { isAppleMobileDevice } from '~/utils/browser';
import { isSoldOut, isUpcomingRelease } from '~/utils/products';

import type { User } from '../../../../types/User';
import DownloadAppBanner from './DownloadAppBanner';
import NotificationBanner from './NotificationBanner';

function hasUserSetAlert(legacyId: string, user: User) {
  return user.actions?.alerts.products.some((alert) => alert.id === legacyId);
}

const BannerToDisplay = ({ onDismiss }: { onDismiss: () => void }) => {
  const user = useUser();
  const product = usePageData<CapiProductPage>();

  if (!product.allow_user_notifications) return null;

  if (hasUserSetAlert(product.legacy_id, user)) return null;

  const stockStatus = product.stock_status;
  const releaseDate = product.date.released;

  if (isSoldOut(releaseDate, stockStatus))
    return <NotificationBanner bannerType="sold-out" onDismiss={onDismiss} />;

  if (isUpcomingRelease(releaseDate, stockStatus))
    return isAppleMobileDevice(navigator.userAgent) ? (
      <DownloadAppBanner onDismiss={onDismiss} />
    ) : (
      <NotificationBanner bannerType="upcoming" onDismiss={onDismiss} />
    );

  return null;
};

const Banner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 5000);

    return () => clearTimeout(timeout);
  }, []);

  return show ? <BannerToDisplay onDismiss={() => setShow(false)} /> : null;
};

export default Banner;
